import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-report-analysis',
  templateUrl: './report-analysis.component.html',
  styleUrls: ['./report-analysis.component.scss'],
})
export class ReportAnalysisComponent implements OnInit, OnDestroy {
  @Input('scoringSections') scoringSections: any;
  @Input('isDigital') isDigital: boolean = false;
  roleSubscription: Subscription;
  role: string = '';
  constructor(private router: Router, private commonService: CommonService) {
    this.roleSubscription = this.commonService
      .getUserRole()
      .subscribe((role: string) => {
        this.role = role;
      });
  }

  ngOnInit() {
    console.log('scoring sections ----- ', this.scoringSections);
  }
  calculatePercentage(correct: any, total: any) {
    return Math.round((correct / total) * 100);
  }

  // ** changed sectionId to tst_id
  goToLearningModule(tst_id: number, subTopicId: number): void {
    console.log('tst_id: ', tst_id);
    this.router.navigateByUrl(
      `/student-learning?sectionId=${tst_id}&subTopicId=${subTopicId}`
    );
  }

  ngOnDestroy(): void {
    this.roleSubscription.unsubscribe();
  }
}
